import * as React from 'react';
import { useAppHookContext } from '@nkr/utils/rest-api';
import useCoachCounts from '@nkr/store/microsites/hooks/use-coach-counts';
import useCoachList from '@nkr/store/microsites/hooks/use-coach-list';
import useSelectedCoach from '@nkr/store/microsites/hooks/use-selected-coach';
import { ContentWrapper, coachPickerStyles } from './styles';
import CoachTabs, { readCoachSearchFromUrl } from './coach-tabs';
import NotificationsPanel from './notifications-panel';
import TodoPanel from './todo-panel';

const CoachActionCenter: React.FC = () => {
    const { app } = useAppHookContext();
    const { contactId, group } = app.user;
    const { coachList } = useCoachList();
    const { activeContactId, setCoach, isSelected } = useSelectedCoach(contactId, group.isSuper);
    const { counts } = useCoachCounts(activeContactId);

    React.useEffect(() => {
        if (group.isSuper && coachList.length > 0 && !isSelected) {
            setCoach(coachList[0].contactId);
        }
    }, [coachList]);

    return (
        <ContentWrapper className='container-fluid'>
            {group.isSuper && (
                <select
                    className='form-control'
                    style={coachPickerStyles.select}
                    value={activeContactId ?? ''}
                    onChange={e => setCoach(Number(e.target.value))}
                >
                    {coachList.map(c => (
                        <option key={c.id} value={c.contactId}>{c.firstName} {c.lastName}</option>
                    ))}
                </select>
            )}
            <CoachTabs contactId={activeContactId} counts={counts} search={readCoachSearchFromUrl()} />
            <NotificationsPanel contactId={activeContactId} />
            <TodoPanel counts={counts} />
        </ContentWrapper>
    );
};

export default CoachActionCenter;
